<template>
  <div class="w-full">
    <div class="flex items-center flex-wrap rounded mb-1 bg-gray-lighter p-2"
         v-for="(product, index) in products"
         :key="index">
      <vue-button :icon="product.prepared ? 'box-solid' : 'box-open-solid'"
                  class="btn text-gray btn-xs btn-outline btn-primary"
                  @click="togglePrepared(product)"/>
      <div class="w-10 mr-2 md:mr-4 text-right flex-no-shrink">
        <span class="text-2xl text-gray-dark mr-2 font-bold" v-text="product.quantity"></span>
      </div>
      <div class="flex-1">
        <p class="text-lg font-medium text-gray-darker leading-none" v-text="product.name"></p>
        <span class="text-gray-dark" v-text="product.note"></span>
      </div>
      <div class="flex justify-end items-center" v-if="!disabled">
        <vue-button icon="edit-pencil"
                    class="btn text-gray btn-xs btn-outline btn-primary"
                    @click="$modal.open('cart-product', product)"/>
        <confirm-button popover-type="popover-left"
                        btn-icon="close"
                        btn-class="btn text-gray btn-xs btn-outline btn-primary ml-2"
                        btn-confirm-text="Supprimer"
                        @confirmed="handleDelete(product)"/>
      </div>
    </div>
  </div>
</template>

<script>
/* globals axios route */
import ErrorHandler from '../../core/ErrorHandler';
import ConfirmButton from '../ConfirmButton.vue';

export default {
  props: {
    products: {
      type: Array,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  components: {ConfirmButton},

  methods: {
    handleDelete(product) {
      axios
          .delete(route('api.cartsProducts.destroy', product.cart_product_id))
          .then(({data}) => Event.fire('cartUpdated', data.data))
          .catch(error => new ErrorHandler(error).dispatch());
    },

    togglePrepared(product) {
      product.prepared
          ? this.markAsUnPrepared(product)
          : this.markAsPrepared(product);
    },

    markAsPrepared(product) {
      axios
          .post(route('api.cartsProducts.prepared.store', product.cart_product_id))
          .then(({data}) => {
            Event.fire('cartUpdated', data.data);
            this.$notify({
              type: 'success',
              title: 'Succès',
              text: 'Le produit a été marqué comme <strong>préparé</strong>.',
            });
          })
          .catch(error => new ErrorHandler(error).dispatch());
    },

    markAsUnPrepared(product) {
      axios
          .delete(route('api.cartsProducts.prepared.destroy', product.cart_product_id))
          .then(({data}) => {
            Event.fire('cartUpdated', data.data)
            this.$notify({
              type: 'success',
              title: 'Succès',
              text: 'Le produit a été marqué comme <strong>non préparé</strong>.',
            });
          })
          .catch(error => new ErrorHandler(error).dispatch());
    }
  },
};
</script>
